/**
 * Field-level diff for pending approvals (Week 2).
 * @param {{ diff?: Array<{ path: string, before: unknown, after: unknown }> }} props
 */
export default function DiffView({ diff }) {
  const rows = Array.isArray(diff) ? diff : [];
  if (rows.length === 0) {
    return <p className="text-dim text-xs">No field-level changes in diff payload.</p>;
  }

  const max = 80;
  const shown = rows.slice(0, max);

  return (
    <div className="space-y-2">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Changes</p>
      <ul className="max-h-52 space-y-2 overflow-y-auto font-mono text-[11px] leading-snug text-slate-300">
        {shown.map((row, i) => (
                      <li key={i} className="border-l border-[rgb(var(--idaxis-accent-primary-rgb)/0.25)] pl-2">
                        <div className="text-[rgb(var(--idaxis-accent-primary-rgb)/0.9)]">{String(row.path || "")}</div>
            <div className="mt-0.5 break-all text-slate-500">
              <span className="text-slate-600">{truncate(JSON.stringify(row.before), 120)}</span>
              <span className="mx-1 text-slate-600">→</span>
              <span>{truncate(JSON.stringify(row.after), 120)}</span>
            </div>
          </li>
        ))}
      </ul>
      {rows.length > max ? (
        <p className="text-[10px] text-slate-600">{rows.length - max} more rows truncated.</p>
      ) : null}
    </div>
  );
}

function truncate(s, n) {
  const str = String(s ?? "");
  if (str.length <= n) return str;
  return `${str.slice(0, n)}…`;
}
